import axios from "axios";
import ConstantList from "../../appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/notificationpatient";
const API_PATH_NOTIFICATION = ConstantList.API_ENPOINT + "/api/notification";
const API_PATH_TRANSFER = ConstantList.API_ENPOINT + "/api/patient-transfer";

export const patientManagementNotificationPatient = (searchObject) => {
    var url = API_PATH + "/paging-etb-patient-manager";
    return axios.post(url, searchObject);
};

export const transferInNotAccept = () => {
    var url = API_PATH_TRANSFER + "/tranferin-not-accept";
    return axios.get(url)
};

export const transferOutNotAccept = () => {
    var url = API_PATH_TRANSFER + "/count-patient-transfer-out-in-and-not-accepted";
    return axios.get(url)
};

export const getNotificationById = (id) => {
    var url = API_PATH_NOTIFICATION + "/" + id;
    return axios.get(url)
};